// @flow

// import React, { useState } from 'react'
import React from 'react'
import glamorous from 'glamorous'
import { css } from 'glamor'
import PropTypes from 'prop-types'
import getContent from 'pp-react-l10n'
import {
  TextDisplay,
  IconButton,
  v2white,
  v2grey400,
  Button,
} from '@paypalcorp/pp-react'
import { V2AddIcon, V2SubtractIcon } from '@paypalcorp/pp-react-icons'
import { getFormattedAmount } from '../amount-utils'
const l10n = getContent('pages/shops/cart')

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  backgroundColor: v2white,
})

const Price = glamorous.div({
  height: '64px',
  width: '210px',
  '& #txtDsplyVlu_basic': {
    display: 'inline-flex',
    alignItems: 'center',
    paddingTop: '0',
    paddingBottom: '0',
    fontSize: '28px',
  },
  '& #message_text-input-basic': {
    fontSize: '14px',
    marginTop: '-5px',
  },
})

const Quantity = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '72px',
  width: '170px',
  border: '1px solid',
  borderColor: v2grey400,
  boxSizing: 'border-box',
  borderRadius: '4px',
  padding: '0 12px',
  '& #txtDsplyVlu_basic': {
    fontSize: '18px',
    fontWeight: 'bold',
    paddingRight: '0',
  },
})

const WidgetPrice = css({
  marginBottom: '-15px',
})

QuantityWidget.propTypes = {
  productId: PropTypes.string,
  price: PropTypes.number,
  currencyCode: PropTypes.string,
  availableItems: PropTypes.number,
  availableText: PropTypes.string,
  quantity: PropTypes.number,
  onQuantityChange: PropTypes.func,
  showRemoveText: PropTypes.bool,
  showQuantityAdjuster: PropTypes.bool,
  // updateTotalPrice: PropTypes.bool,
}

QuantityWidget.defaultProps = {
  productId: 1,
  price: 0,
  currencyCode: 'USD',
  availableItems: 0,
  availableText: '',
  showRemoveText: false,
  showQuantityAdjuster: false,
  // updateTotalPrice: false,
  quantity: 0,
  shopHandle: '',
  onQuantityChange: () => {},
  handleRemove: () => {},
}

function QuantityWidget(props) {
  const {
    productId,
    price,
    currencyCode,
    availableItems,
    availableText,
    showRemoveText,
    showQuantityAdjuster,
    quantity,
    shopHandle,
    // onQuantityChange,
    handleRemove,
    // updateTotalPrice,
  } = props

  // const formatPrice = (update, productPrice, productQuantity) =>
  // getFormattedAmount({
  //   amount: update
  //     ? (Math.round(productPrice * productQuantity * 100) / 100).toString()
  //     : productPrice.toString(),
  //   currencyCode,
  //   symbolIsoCurrency: true,
  // })

  const formatPrice = productPrice =>
    getFormattedAmount({
      amount: productPrice.toString(),
      currencyCode,
      symbolIsoCurrency: true,
    })

  // const [stateQuantity, setStateQuantity] = useState(quantity)
  // const [addEnabled, setAddEnabled] = useState(quantity < availableItems)
  // const [removeEnabled, setRemoveEnabled] = useState(quantity > 1)

  // const changeQuantity = (addedItems, changeType, productId, shopHandle) => {
  //   setStateQuantity(addedItems)
  //   setAddEnabled(addedItems < availableItems)
  //   setRemoveEnabled(addedItems > 1)
  //   onQuantityChange(addedItems, changeType, productId, shopHandle)
  // }

  const removeEnabled = false
  const addEnabled = false

  return (
    <Container>
      <Price>
        {showRemoveText ? (
          <>
            <TextDisplay
              name="basic"
              // value={`${formatPrice(updateTotalPrice, price, stateQuantity)}`}
              value={`${formatPrice(price)}`}
              className={`${WidgetPrice}`}
            />
            <Button
              tertiary
              onClick={() => handleRemove(shopHandle, productId)}
            >
              {l10n('removeButton')}
            </Button>
          </>
        ) : (
          <TextDisplay
            name="basic"
            value={`${formatPrice(price)}`}
            helperText={`${availableItems} ${availableText}`}
          />
        )}
      </Price>
      {showQuantityAdjuster ? (
        <Quantity>
          <IconButton
            buttonType="secondary"
            svgIconComponent={V2SubtractIcon}
            // onClick={() =>
            //   changeQuantity(stateQuantity - 1, -1, productId, shopHandle)
            // }
            disabled={!removeEnabled}
          />
          {/* <TextDisplay name="basic" value={stateQuantity} /> */}
          <TextDisplay name="basic" value={quantity} />
          <IconButton
            buttonType="secondary"
            svgIconComponent={V2AddIcon}
            // onClick={() =>
            //   changeQuantity(stateQuantity + 1, 1, productId, shopHandle)
            // }
            disabled={!addEnabled}
          />
        </Quantity>
      ) : null}
    </Container>
  )
}

export default QuantityWidget
